import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    flex-direction: column;
    width: 100%;
`
export const EffectColor = styled(Box)`
    left: 50%;
    --awb-spacer-height: 99px;
    --awb-divider-height: 99px;
    --awb-spacer-padding-top: inherit;
    --awb-sep-padding: 0;
    --awb-svg-padding: 0;
    height: 80px;
`
export const EffectColorInvert = styled(Box)`
    left: 50%;
    --awb-spacer-height: 99px;
    --awb-divider-height: 99px;
    --awb-spacer-padding-top: inherit;
    --awb-sep-padding: 0;
    --awb-svg-padding: 0;
    height: 80px;
    transform: rotate(180deg);
`
export const OverContainerColor = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    background: ${({ theme }) => theme.colors.primary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: row;
        height: 400px;
    }
`
export const ContentEffect = styled(Box)`
    width: 99%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1380px;
        flex-direction: column;
        justify-content: start;
        align-items: center;
    }
`

export const Content = styled(Box)`
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const TitleSection = styled(Typography)`
    font-family: Poppins, sans-serif;
    letter-spacing: 0;
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 28px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        font-size: 32px;

        line-height: 41px;
    }
`

export const ContentMapSection = styled(Box)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-wrap: nowrap;
    }
`
